import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import newtheme from '../../../newtheme';
import Input from '../../../components/Input';
import { editEmail, resetSpecialAccessState, verifySpecialAccess } from '../state/actions';
import text from '../../../locale';
import { openModal } from '../../../actions/modal';
import SignupForSpecialAccessModal from '../containers/SignupForSpecialAccessModal';
import NoSpecialAccessFoundModalComponent from './NoSpecialAccessFoundModalComponent';
import ISpecialAccessResponse from '../types/ISpecialAccessResponse';

interface IProps {
    email: string;
    accessData: ISpecialAccessResponse;
    accessDetermined: boolean;
    loading: boolean;
    error?: any;
    verifySpecialAccess: typeof verifySpecialAccess;
    resetSpecialAccessState: typeof resetSpecialAccessState;
    openModal: typeof openModal;
    editEmail: typeof editEmail;
}

interface IState {
    isOpen: boolean;
}

class VerifySpecialAccessComponent extends React.Component<IProps, IState> {
    public verifyAccess = () => {
        this.props.verifySpecialAccess(this.props.email);
    };

    public onChangeEmail = (value: string) => {
        this.props.editEmail(value);
    };

    public onModalClose = () => {
        this.props.resetSpecialAccessState();
    };

    public onSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
    };

    public render() {
        const {
            error, accessDetermined, accessData, email, loading,
        } = this.props;

        const specialAccessFound = accessDetermined && accessData.hasAccess;
        const noSpecialAccessFound = accessDetermined && !accessData.hasAccess;

        return (
            <form onSubmit={this.onSubmit} className={css(styles.form)}>
                <div className={css(styles.formActions)}>
                    <Input id="signup-email" type="email" value={email} onChange={this.onChangeEmail} placeholder="Enter your email address" noMargin disabled={loading} />

                    <div className={css(styles.buttonAndLoader)}>
                        <button type="button" className={css(styles.button, loading && newtheme.coreStyles.noVisibility)} onClick={this.verifyAccess}>
                            Verify Access
                        </button>
                        <div className={css(styles.button, styles.loading, !loading && newtheme.coreStyles.noVisibility)}>
                            Verifying...
                        </div>
                    </div>

                </div>

                <p className={css(styles.error, !error && newtheme.coreStyles.noVisibility)}>
                    Sorry, an error occurred!
                    <br />
                    <span className={css(styles.contact)} id={text.nav.CONTACT}>Chat to the Noa support team for help.</span>
                </p>

                <SignupForSpecialAccessModal close={this.onModalClose} open={specialAccessFound} />
                <NoSpecialAccessFoundModalComponent close={this.onModalClose} open={noSpecialAccessFound} openModal={this.props.openModal} />
            </form>
        );
    }
}

const styles = StyleSheet.create({
    form: {
        width: '100%',
    },
    formActions: {
        [newtheme.cssBreakpoints.small]: {
            flexDirection: 'column',
        },
        display: 'flex',
        flexDirection: 'row',
    },
    buttonAndLoader: {
        position: 'relative',
    },
    button: {
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 16,
            padding: '0px 15px',
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 14,
            borderRadius: 10,
            height: 50,
            margin: 0,
            marginTop: 15,
            width: '50%',
        },
        [newtheme.cssBreakpoints.tiny]: {
            height: 40,
            marginTop: 7,
        },
        ':hover': {
            backgroundColor: 'white',
            color: 'black',
            stroke: 'black',
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: newtheme.colors.primaryBlue,
        color: 'white',
        stroke: 'white',
        border: 'none',
        whiteSpace: 'nowrap',
        fontSize: 18,
        fontWeight: 500,
        padding: '0px 30px',
        borderRadius: 10,
        marginLeft: 20,
        width: '100%',
        height: '100%',
    },
    error: {
        marginTop: 10,
        fontSize: 16,
        color: 'red',
        fontWeight: 600,
    },
    loading: {
        ':hover': {
            backgroundColor: '#3CB371',
            color: newtheme.colors.white,
        },
        backgroundColor: '#3CB371',
        color: newtheme.colors.white,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    },
    contact: {
        textDecoration: 'underline',
        cursor: 'pointer',
    },
});

export default VerifySpecialAccessComponent;
